import { PropsWithChildren } from 'react'

export const Body = ({ children }: PropsWithChildren<{}>) => (
  <p className="text-ink leading-[26px] text-[18px] font-decimal">{children}</p>
)

export const H1 = ({ children }: PropsWithChildren<{}>) => (
  <h1 className="text-green uppercase leading-[31px] text-[26px] font-decimal font-bold">
    {children}
  </h1>
)
